import Text from '../../../../atoms/Text';
import ExchangeIcon from '../ExchangeIcon';

interface ITickerFooterMobileProps {
  isInViewWatchlist: boolean;
  onToggleWatchlist(): void;
  exchange: string;
}

const TickerFooterMobile = ({
  isInViewWatchlist,
  onToggleWatchlist,
  exchange,
}: ITickerFooterMobileProps) => {
  const watchlistClassName = isInViewWatchlist
    ? 'active icon-star-active'
    : 'normal icon-star';

  const handleClick = (e: any) => {
    e.stopPropagation();
    onToggleWatchlist();
  };
  return (
    <div className='tickers_footer_mobile'>
      <ExchangeIcon
        exchange={exchange}
        textProps={{ className: 'text--grey-400' }}
        imageProps={{ style: { marginLeft: 8 } }}
      />
      <div
        onClick={handleClick}
        className={`tickers_footer_mobile__star tickers_footer_mobile__star--${watchlistClassName}`}
      />
    </div>
  );
};

export default TickerFooterMobile;
